module.exports = __webpack_public_path__ + "img/listo.0220dad7.gif";